import React from 'react'
import Hero from '../Components/Hero'
import ContactFormTwo from '../Components/ContactFormTwo'
import OurCustomers from '../Components/OurCustomers'
import Sesvan from '../Components/Sesvan'
import Heven from '../Components/Heven'
import Hivio from '../Components/Hivio'
import TopServices from '../Components/TopServices'
import UnleashPotential from '../Components/UnleashPotential'
import WhiteMenuSection from '../Components/WhiteMenuSection'
import Recommendations from '../Components/Recommendations'
import Footer from '../Components/Footer'

const Home = () => {
    return (
        <div>
            <div>
                <div className='parallax-part'>
                <Hero />
                <OurCustomers />
                <Sesvan />
                <Heven />
                <Hivio />
                </div>
                <div className='standard-part'>
                <TopServices />
                <UnleashPotential />
                <WhiteMenuSection />
                <Recommendations />
                </div>
                <div className='contact-popup'>
                    <ContactFormTwo />
                </div>
            </div>
        </div>
    )
}

export default Home